module.exports = __webpack_public_path__ + "static/media/game-loading.270d528b.png";